import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const businessCategoryService = {
	/**
	 * Get all business categories
	 */
	getBusinessCategories(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/business_categories', config)
	},
}

export default businessCategoryService
